// Iter34 — Three-way segmented theme switcher. Used in TopBar user dropdown
// AND in Settings → Appearance.
import React, { useEffect, useState } from "react";
import axios from "axios";
import { readStoredTheme, setTheme } from "../lib/theme";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const OPTIONS = [
  { value: "light", icon: "☀️", label: "Light" },
  { value: "auto",  icon: "💻", label: "Auto" },
  { value: "dark",  icon: "🌙", label: "Dark" },
];

export const ThemeSwitcher = ({ size = "sm", showLabels = true }) => {
  const [current, setCurrent] = useState(readStoredTheme());

  // Keep in sync when another tab changes the preference.
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "sitroom_theme") setCurrent(readStoredTheme());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const handlePick = (val) => {
    setCurrent(val);
    setTheme(val);
    // Best-effort persist to user.theme (silently ignore 404 if endpoint missing)
    axios
      .patch(`${API}/users/me`, { theme: val })
      .catch(() => {});
  };

  const pad = size === "lg" ? "px-3 py-1.5" : "px-2 py-1";
  const fs = size === "lg" ? 12 : 11;

  return (
    <div
      className="inline-flex rounded-md"
      style={{
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.10)",
        padding: 2,
        gap: 2,
      }}
      data-testid="theme-switcher"
      data-theme-current={current}
    >
      {OPTIONS.map((opt) => {
        const active = current === opt.value;
        return (
          <button
            key={opt.value}
            onClick={() => handlePick(opt.value)}
            className={`${pad} rounded transition-colors flex items-center gap-1.5`}
            style={{
              background: active ? "var(--cmd-blue)" : "transparent",
              color: active ? "#fff" : "var(--text-dim)",
              fontFamily: "'DM Mono', monospace",
              fontSize: fs,
              cursor: "pointer",
              border: "none",
              letterSpacing: "0.4px",
            }}
            aria-pressed={active}
            data-testid={`theme-switcher-option-${opt.value}`}
            data-active={active ? "true" : "false"}
          >
            <span aria-hidden style={{ fontSize: fs + 2 }}>{opt.icon}</span>
            {showLabels && <span>{opt.label}</span>}
          </button>
        );
      })}
    </div>
  );
};
